import React, { useState } from "react";

import img1 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.36.jpeg";
import img2 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.36 (1).jpeg";
import img3 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.37.jpeg";
import img4 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.37 (1).jpeg";
import img5 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.38.jpeg";
import img6 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.38 (1).jpeg";
import img7 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.39.jpeg";
import img8 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.39 (1).jpeg";
import img9 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.40.jpeg";
import img10 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.40 (1).jpeg";
import img11 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.41.jpeg";
import img12 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.41 (1).jpeg";
import img13 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.42.jpeg";
import img14 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.42 (1).jpeg";
import img15 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.42 (2).jpeg";
import img16 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.43.jpeg";
import img17 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.43 (1).jpeg";
import img18 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.44.jpeg";
import img19 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.44 (1).jpeg";
import img20 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.45.jpeg";
import img21 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.45 (1).jpeg";

const categories = [
  "All",
  "Necklace Sets",
  "Long Haar",
  "Bridal Chokers",
  "Rings",
  "Malas",
];

const items = [
  { src: img1, category: "Necklace Sets", title: "Antique Kundan Set" },
  { src: img2, category: "Rings", title: "Floral Emerald Ring" },
  { src: img3, category: "Rings", title: "Coral Shell Ring" },
  { src: img4, category: "Long Haar", title: "Temple Long Haar" },
  { src: img5, category: "Malas", title: "Black Bead Gold Mala" },
  { src: img6, category: "Necklace Sets", title: "Navratna Necklace" },
  { src: img7, category: "Necklace Sets", title: "Pearl Antique Choker" },
  { src: img8, category: "Long Haar", title: "Royal Rani Haar" },
  { src: img9, category: "Long Haar", title: "Layered Gold Haar" },
  { src: img10, category: "Long Haar", title: "Emerald Bead Rani Haar" },
  { src: img11, category: "Long Haar", title: "Traditional Long Haar" },
  { src: img12, category: "Necklace Sets", title: "Suvarnakala Choker" },
  { src: img13, category: "Necklace Sets", title: "Classic Gold Set" },
  { src: img14, category: "Necklace Sets", title: "Bead Drop Necklace" },
  { src: img15, category: "Bridal Chokers", title: "Grand Bridal Choker" },
  { src: img16, category: "Bridal Chokers", title: "Heavy Bridal Haar" },
  { src: img17, category: "Bridal Chokers", title: "Kundan Bridal Set" },
  { src: img18, category: "Necklace Sets", title: "Signature Gold Set" },
  { src: img19, category: "Necklace Sets", title: "Enishka Gold Set" },
  { src: img20, category: "Necklace Sets", title: "Round Pendant Set" },
  { src: img21, category: "Long Haar", title: "Temple Rani Haar" },
];

export default function Catalogue() {
  const [active, setActive] = useState("All");
  const [preview, setPreview] = useState(null);

  const filtered =
    active === "All" ? items : items.filter((i) => i.category === active);

  return (
    <section
      id="catalogue"
      className="relative py-16 sm:py-20 md:py-28 bg-gradient-to-b from-gray-50 via-white to-cream"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-12">
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.35em] text-gold-dark font-semibold mb-4">
            <span className="h-px w-8 bg-gold" />
            Our Collections
            <span className="h-px w-8 bg-gold" />
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-maroon font-bold leading-tight">
            Signature{" "}
            <span className="gold-gradient-text">Bridal Collections</span>
          </h2>
          <p className="mt-4 sm:mt-5 text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed">
            From sacred bridal sets to exquisite rani haars in our signature
            Rabari Ghat work  each piece is a timeless expression of
            heritage, purity and love.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 sm:gap-3 mb-8 md:mb-10">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActive(cat)}
              className={`px-3 sm:px-5 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-medium transition-all border ${
                active === cat
                  ? "bg-maroon text-white border-maroon shadow-lg"
                  : "bg-white text-maroon border-gold/40 hover:border-gold hover:bg-gold/10"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-6">
          {filtered.map((item, idx) => (
            <button
              key={idx}
              onClick={() => setPreview(item)}
              className="group relative overflow-hidden rounded-2xl bg-white shadow-md hover:shadow-2xl border border-gray-200 hover:border-gold transition-all duration-300"
            >
              <div className="aspect-square overflow-hidden bg-cream">
                <img
                  src={item.src}
                  alt={item.title}
                  loading="lazy"
                  className="w-full h-full object-cover scale-[1.45] group-hover:scale-[1.6] transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-maroon/80 via-maroon/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                <div className="text-left">
                  <div className="text-[10px] uppercase tracking-widest text-gold mb-1">
                    {item.category}
                  </div>
                  <div className="text-white font-serif font-semibold text-sm md:text-base">
                    {item.title}
                  </div>
                </div>
              </div>
              <div className="p-3 flex items-center justify-between border-t border-gold/10">
                <span className="text-xs text-gray-500 uppercase tracking-wider truncate">
                  {item.category}
                </span>
                <span className="text-maroon font-serif text-sm font-semibold truncate ml-2">
                  {item.title}
                </span>
              </div>
            </button>
          ))}
        </div>

        <div className="mt-14 text-center">
          <p className="text-gray-700 mb-5">
            Looking for something bespoke? Visit our showroom for a full
            personalised experience.
          </p>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 bg-maroon text-white px-7 py-3 rounded-full font-medium shadow-lg hover:bg-maroon-dark transition-colors"
          >
            Book a Visit
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </a>
        </div>
      </div>

      {preview && (
        <div
          className="fixed inset-0 z-[60] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={() => setPreview(null)}
        >
          <div
            className="relative max-w-3xl w-full bg-white rounded-2xl overflow-hidden shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setPreview(null)}
              className="absolute top-3 right-3 z-10 bg-white/90 hover:bg-white text-maroon rounded-full w-9 h-9 flex items-center justify-center shadow"
              aria-label="Close"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
            <div className="w-full max-h-[75vh] aspect-square overflow-hidden bg-cream flex items-center justify-center">
              <img
                src={preview.src}
                alt={preview.title}
                className="w-full h-full object-cover scale-[1.4]"
              />
            </div>
            <div className="p-5 border-t border-gold/20">
              <div className="text-xs uppercase tracking-widest text-gold-dark">
                {preview.category}
              </div>
              <div className="font-serif text-xl text-maroon font-bold mt-1">
                {preview.title}
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
